module.exports = __webpack_public_path__ + "static/media/vod_play.15d91ccf.svg";